import moment from "moment";
import { FormatNumber2 } from "../../utility/functions/formatNumber";
import {
  renderCellLeft,
  renderCellRight,
} from "../../utility/functions/common";

export const PurchaseSummaryColumns = (width) => {
  const columns = [
    {
      field: "DATE",
      accessor: "DATE",
      headerAlign: "center",

      width: width < 768 ? 100 : 100,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return renderCellLeft(
          params.value ? moment(params.value).format("DD-MM-yyyy") : ""
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Date
        </div>
      ),
    },
    {
      field: "DEBIT_NOTE_NO",
      accessor: "DEBIT_NOTE_NO",
      type: "string",
      headerAlign: "center",
      width: width < 768 ? 110 : width < 1400 ? 110 : 110,
      headerClassName: "super-app-theme--header",

      renderCell: (param) => {
        return renderCellLeft(param.value);
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Debit Note No.
        </div>
      ),
    },

    {
      field: "ACCOUNT_NO",
      accessor: "ACCOUNT_NO",
      type: "string",
      width: 100,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return renderCellLeft(param.value);
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Account No.
        </div>
      ),
    },

    {
      field: "NAME",
      accessor: "NAME",
      type: "string",
      width: width < 768 ? 150 : width < 1400 ? 250 : 220,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return renderCellLeft(param.value);
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          {" "}
          Party Name
        </div>
      ),
    },
    {
      field: "GTOTAL",
      accessor: "GTOTAL",
      type: "string",
      headerAlign: "center",
      width: width < 768 ? 150 : width < 1400 ? 150 : 150,
      headerClassName: "super-app-theme--header",

      renderCell: (param) => {
        return renderCellRight(FormatNumber2(param.value));
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Grand total
        </div>
      ),
    },
  ];

  return columns;
};
